export default "__VITE_PUBLIC_ASSET__ae4b642f__"